import { ScmType } from "@protos/common/v1/common";
import { getBranchName, isPullRequest } from "@shared/utils";

export const getProviderRefUrl = (
  origin: ScmType | undefined,
  repoUrl: string | undefined,
  pullRequestId: number | undefined,
  ref: string
) => {
  let refUrl;
  switch (origin) {
    case ScmType.GITHUB:
    case ScmType.GITHUB_ENTERPRISE:
      if (isPullRequest(ref)) {
        refUrl = `${repoUrl}/pull/${pullRequestId}`;
      } else {
        refUrl = `${repoUrl}/tree/${getBranchName(ref)}`;
      }
      break;
    case ScmType.GITLAB:
    case ScmType.GITLAB_SELFMANAGED:
      if (pullRequestId) {
        refUrl = `${repoUrl}/-/merge_requests/${pullRequestId}`;
      } else {
        refUrl = `${repoUrl}/-/tree/${getBranchName(ref)}`;
      }
      break;
    case ScmType.BITBUCKET:
    case ScmType.BITBUCKET_DATACENTER:
      if (pullRequestId) {
        refUrl = `${repoUrl}/pull-requests/${pullRequestId}`;
      } else {
        refUrl = `${repoUrl}/browse/?at=${getBranchName(ref)}`;
      }
      break;
    case ScmType.AZURE_DEVOPS:
      if (pullRequestId) {
        refUrl = `${repoUrl}/pullrequest/${pullRequestId}`;
      } else {
        refUrl = `${repoUrl}?refName=${ref}`;
      }
      break;
    default:
      refUrl = repoUrl;
  }

  return refUrl;
};
